
<ngx-glide *ngIf="lastPaymentmode?.length" [showArrows]="false" [showBullets]="true" [type]="'slider'" [bound]="true" [gap]="10"
    [arrowLeftLabel]="''" [arrowRightLabel]="''"
    [perView]="1.1">
    <div class="container" *ngFor="let item of lastPaymentmode; let j = index">
      <div class="leftcontent">
        <div class="amount"><app-currency-icon *ngIf="true" [currency]="'INR'"></app-currency-icon>{{lastPaymentmode[j].amount}}</div>
        <div class="lastpaymode">
          <span class="icons payment-icons-v1 OP_{{lastPaymentmode[j]?.payment_mode}} {{lastPaymentmode[j]?.payment_mode_value?.toUpperCase()}}"></span>
          <div class="op-text">
            <div class="op-value" *ngIf="lastPaymentmode[j]?.payment_mode==='CARD'">***{{lastPaymentmode[j]?.checksum?.last4}}</div>
            <div class="op-value" *ngIf="lastPaymentmode[j]?.payment_mode==='NB'">{{lastPaymentmode[j]?.checksum?.name}}</div>
            <div class="op-value" *ngIf="lastPaymentmode[j]?.payment_mode==='WALLET'">{{lastPaymentmode[j]?.payment_mode_value?.toLowerCase()}}</div>
            <div class="op-value {{lastPaymentmode[j]?.payment_mode}}" *ngIf="lastPaymentmode[j]?.payment_mode==='UPI' && lastPaymentmode[j]?.payment_mode_value==='VPA'">{{lastPaymentmode[j]?.checksum}}</div>
            <div class="op-value" *ngIf="lastPaymentmode[j]?.payment_mode==='UPI' && lastPaymentmode[j]?.payment_mode_value!=='VPA'">{{lastPaymentmode[j]?.payment_mode_value}}</div>
          </div>
        </div>
      </div>
      <button mat-button (click)="donate(j)">
        <div *ngIf="!paymentV2.isOrderLoading" class="text">
          Contribute <i class="material-icons">chevron_right</i>
        </div>
        <div *ngIf="paymentV2.isOrderLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
      </button>
      <!-- <div class="button">
      </div> -->
    </div>
  </ngx-glide>


  <div class="upi-timer" *ngIf="vars.upiTimer">
    <app-payment-sip-upi-timer></app-payment-sip-upi-timer>
  </div> 